import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WHATSAPP_NUMBER = "919999999999"; // ✅ replace with your number (countrycode + number)
const WHATSAPP_TEXT = encodeURIComponent("Hi, I want to consult a Chartered Accountant for GST/ITR/Compliance.");

export default function WhatsAppButton() {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_TEXT}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-emeraldBrand-500 text-white shadow-soft transition hover:scale-[1.03] active:scale-[0.98]"
      title="WhatsApp Us"
    >
      <FaWhatsapp size={26} />
    </a>
  );
}
